import {
  Box,
  Button,
  CircularProgress,
  Container,
  FormHelperText,
  Grid,
  Link,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useState, useEffect, useRef } from "react";
import { signUpCustomer } from "../../api/customer";
import useErrorHandler from "../../hooks/useErrorHandler";
import useSnackbar from "../../hooks/useSnackbar";
import VastEdgeLogo from "../../images/vastedge-logo-white-small.png";
import VastEdgeBkg from "../../images/signup-bg.jpg";

import { makeStyles } from "@mui/styles";
import { blue } from "@mui/material/colors";
import Captcha from "../../components/captcha";
// import "./Register.css";
//document.body.style = 'background: #e3e4e6; ';
const useStyles = makeStyles((theme) => ({
  odrBox: {
    "@media (min-width: 520px)": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "absolute",
      transform: "translate(-50%, -50%)",
      top: "50%",
      left: "50%",
    },
    "@media (max-width: 520px)": {
      marginBottom: "20px",
    },
  },
  odrPaperWidth: {
    maxWidth: "1000px",
    boxShadow: "rgba(0, 0, 0, 0.15) 0px 2px 8px !important",
    backgroundColor: "#fff !important",
    color: "rgba(0, 0, 0, 0.87) !important",
    WebkitTransition:
      "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important",
    borderRadius: "4px !important",
  },
  odrRegPage: {
    backgroundImage: `url(${VastEdgeBkg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    height: "100%",
    position: "absolute",
    left: "0",
    width: "100%",
    maxWidth: "100% !important",
    "@media (max-width: 520px)": {
      position: "relative",
    },
  },
  odrRegHeader: {
    margin: "14px 0px 0px 14px !important",
  },
  odrformScroll: {
    "&::-webkit-scrollbar": {
      width: "0.4em",
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#b9b9bb",
      outline: "1px solid slategrey",
      borderRadius: "14px",
    },
  },
}));
export default function Register() {
  const classes = useStyles();
  const snackbar = useSnackbar();
  const handleError = useErrorHandler();
  const initialValues = {
    email: "",
    company_name: "",
    password: "",
    phone: "",
    firstname: "",
    lastname: "",
    address: "",
    address2: "",
    city: "",
    state: "",
    country: "",
    zipcode: "",
  };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState("");
  const captchaRef = useRef();
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormErrors(validate(formValues));
    const newdata = await captchaRef.current.checkAnswer();
    if (newdata[0] === true) {
      setIsSubmit(true);
    } else if (newdata[1] === "") {
      setErrorMsg("Enter the captcha.");
    } else {
      setErrorMsg("Captcha Mismatch");
    }
  };

  const signUp = async () => {
    setLoading(true);
    try {
      const { data } = await signUpCustomer(formValues);
      snackbar.showSuccess(data.msg);
      setLoading(false);
    } catch (err) {
      captchaRef.current.numRefresh();
      setLoading(false);
      handleError(err);
      // snackbar.showError();
    }
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      signUp();
    }
  }, [formErrors]);
  const validate = (values) => {
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!values.firstname) {
      errors.firstname = "First name is required!";
    }
    if (!values.lastname) {
      errors.lastname = "Last name is required!";
    }
    if (!values.email) {
      errors.email = "Email is required!";
    } else if (!regex.test(values.email)) {
      errors.email = "This is not a valid email format!";
    }
    if (!values.company_name) {
      errors.company_name = "Company Name is required!";
    }
    // if (!values.password) {
    //   errors.password = "Password is required";
    // } else if (values.password.length < 4) {
    //   errors.password = "Password must be more than 4 characters";
    // } else if (values.password.length > 10) {
    //   errors.password = "Password cannot exceed more than 10 characters";
    // }
    if (!values.address) {
      errors.address = "Address is required";
    }
    if (!values.zipcode) {
      errors.zipcode = "Zip code is required";
    }

    if (!values.city) {
      errors.city = "City is required";
    }
    if (!values.state) {
      errors.state = "State is required";
    }
    if (!values.country) {
      errors.country = "Country is required";
    }

    if (!values.phone) {
      errors.phone = "Phone Number is required";
    } else if (values.phone.length < 10 || values.phone.length > 10) {
      errors.phone = "Please enter a valid 10-digit phone number";
    }
    return errors;
  };

  // setFormValues("");
  // setIsSubmit(initialValues);
  return (
    <>
      <Container maxWidth="xl" className={classes.odrRegPage}>
        <Box
          // sx={{ minHeight: "100vh" ,backgroundImage:"url({VastEdgeBkg})"}}
          style={{
            minHeight: "100vh",
            // backgroundImage: `url(${VastEdgeBkg})`
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12} className={classes.odrRegHeader}>
              <Link href="https://www.vastedge.com/">
                <img src={VastEdgeLogo} height="45" />
              </Link>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Box className={classes.odrBox}>
                <Paper className={classes.odrPaperWidth}>
                  {/* <Box p={2}><Typography>Signup</Typography> </Box> */}
                  <Box
                    className={classes.odrformScroll}
                    maxWidth={800}
                    maxHeight={496}
                    overflow="auto"
                    pt={3}
                    px={2}
                    pb={2}
                    component="form"
                    onSubmit={handleSubmit}
                  >
                    <Grid container spacing={2} mb={5}>
                      {/* <Grid item xs={12} md={12} lg={12}>
                        <Box className="reg-title">
                          <Typography variant="h5" fontWeight={700}>
                            Sign up
                          </Typography> */}
                      {/* <Link href="/login" underline="none" variant="body2" className="odrHyperlink">
                          Already have an account?
                        </Link> */}
                      {/* </Box>
                      </Grid> */}
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <TextField
                          size="small"
                          fullWidth
                          label="Email"
                          type="text"
                          name="email"
                          placeholder="Email"
                          value={formValues.email}
                          onChange={handleChange}
                          error={Boolean(formErrors.email)}
                          helperText={formErrors.email}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <TextField
                          size="small"
                          fullWidth
                          label="Company Name"
                          type="text"
                          name="company_name"
                          placeholder="Company Name"
                          value={formValues.company_name}
                          onChange={handleChange}
                          error={Boolean(formErrors.company_name)}
                          helperText={formErrors.company_name}
                        />
                      </Grid>
                      {/* <Grid item xs={12} sm={6} md={6} lg={6}>
                <TextField
                  size="small"
                  fullWidth
                  label="Password"
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={formValues.password}
                  onChange={handleChange}
                />
                <FormHelperText className="error-message">
                  {formErrors.password}
                </FormHelperText>
              </Grid> */}
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <TextField
                          size="small"
                          fullWidth
                          label="Phone"
                          type="number"
                          name="phone"
                          placeholder="Phone number"
                          value={formValues.phone}
                          onChange={handleChange}
                          error={Boolean(formErrors.phone)}
                          helperText={formErrors.phone}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <TextField
                          size="small"
                          fullWidth
                          label="First Name"
                          type="text"
                          name="firstname"
                          placeholder="First name"
                          value={formValues.firstname}
                          onChange={handleChange}
                          error={Boolean(formErrors.firstname)}
                          helperText={formErrors.firstname}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <TextField
                          size="small"
                          fullWidth
                          label="Last Name"
                          type="text"
                          name="lastname"
                          placeholder="Last name"
                          value={formValues.lastname}
                          onChange={handleChange}
                          error={Boolean(formErrors.lastname)}
                          helperText={formErrors.lastname}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <TextField
                          size="small"
                          fullWidth
                          label="Address"
                          type="text"
                          name="address"
                          placeholder="Address"
                          value={formValues.address}
                          onChange={handleChange}
                          error={Boolean(formErrors.address)}
                          helperText={formErrors.address}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <TextField
                          size="small"
                          fullWidth
                          label="Address 2"
                          type="text"
                          name="address2"
                          placeholder="Address 2"
                          value={formValues.address2}
                          onChange={handleChange}
                          error={Boolean(formErrors.address2)}
                          helperText={formErrors.address2}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <TextField
                          size="small"
                          fullWidth
                          label="City"
                          type="text"
                          name="city"
                          placeholder="City"
                          value={formValues.city}
                          onChange={handleChange}
                          error={Boolean(formErrors.city)}
                          helperText={formErrors.city}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <TextField
                          size="small"
                          fullWidth
                          label="State"
                          type="text"
                          name="state"
                          placeholder="State"
                          value={formValues.state}
                          onChange={handleChange}
                          error={Boolean(formErrors.state)}
                          helperText={formErrors.state}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <TextField
                          size="small"
                          fullWidth
                          label="Country"
                          type="text"
                          name="country"
                          placeholder="Country"
                          value={formValues.country}
                          onChange={handleChange}
                          error={Boolean(formErrors.country)}
                          helperText={formErrors.country}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <TextField
                          size="small"
                          fullWidth
                          type="text"
                          label="Zip code"
                          name="zipcode"
                          placeholder="Zip Code"
                          value={formValues.zipcode}
                          onChange={handleChange}
                          error={Boolean(formErrors.zipcode)}
                          helperText={formErrors.zipcode}
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={12} lg={12}>
                          <Box
                          // display="flex" justifyContent="center"
                          >
                            <Captcha errorMsg={errorMsg} ref={captchaRef} />
                            {/* <p st>{errorMsg}</p> */}
                          </Box>
                        </Grid>
                        {loading === false ? (
                          <Grid item xs={12} md={12} lg={12}>
                            <Button
                              color="primary"
                              type="submit"
                              variant="contained"
                              fullWidth
                              size="large"
                              className="blue-button"
                            >
                              Sign Up
                            </Button>
                          </Grid>
                        ) : (
                          <div
                            style={{
                              // do your styles depending on your needs.
                              width: "100%",
                              marginTop: 10,
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <CircularProgress></CircularProgress>
                          </div>
                        )}
                      </Grid>
                    </Grid>
                  </Box>
                </Paper>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </>
  );
}
